(function () {
  function initSection(section) {
    var tabs = section.querySelector(".vacation-routine__tabs");

    if (!tabs || tabs.dataset.vacationRoutineInit === "true") {
      return;
    }

    tabs.dataset.vacationRoutineInit = "true";

    tabs.addEventListener("click", function (event) {
      var tab = event.target.closest(".vacation-routine__tab");

      if (!tab || !section.contains(tab) || tab.classList.contains("is-active")) {
        return;
      }

      var id = tab.getAttribute("data-tab");

      section.querySelectorAll(".vacation-routine__tab").forEach(function (item) {
        var active = item === tab;

        item.classList.toggle("is-active", active);
        item.setAttribute("aria-selected", active ? "true" : "false");
      });

      section.querySelectorAll(".vacation-routine__panel").forEach(function (panel) {
        var active = panel.getAttribute("data-panel") === id;

        panel.classList.toggle("is-active", active);
        panel.hidden = !active;
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll(".vacation-routine").forEach(initSection);
  }

  initAll();

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
